import React, {useContext} from 'react';
import Chip from '@mui/material/Chip';
import TimerIcon from '@mui/icons-material/Timer';
import {TimerContext} from '../../core/TimerContext';

const formatTime = (seconds) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
};

export default function FloatingTimer() {
    const timer = useContext(TimerContext);

    if (!timer || (timer.remainingSeconds <= 0 && !timer.isRunning)) return null;

    return (
        <Chip
            icon={<TimerIcon />}
            label={formatTime(timer.remainingSeconds)}
            color={timer.remainingSeconds === 0 ? 'success' : 'error'}
            clickable={false}
            sx={{
                position: 'fixed',
                bottom: 72,
                left: '50%',
                transform: 'translateX(-50%)',
                zIndex: 1300,
                fontSize: '1rem',
                fontWeight: 'bold',
                height: 40,
                boxShadow: 3,
            }}
        />
    );
}
